import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { useCallback } from "react";
import * as Sentry from "@sentry/react";
import JitsiComponent from "../JitsiComponent/JitsiComponent";
import { useAppSelector } from "../../../../hooks/useRedux";

interface MeetingRoomProps {
    sessionHistoryId: string;
    jitsiToken: string;
    email: string;
    userId: string;
    clientName: string;
}

export default function MeetingRoom({
    jitsiToken,
    sessionHistoryId,
    email,
    userId,
    clientName,
}: MeetingRoomProps) {
    const [searchParams] = useSearchParams();
    const providerName = searchParams.get("with") ?? "";

    const { practice } = useAppSelector((state) => state.userPractice);

    const sendClientJoinedNotification = useCallback(async () => {
        const baseURL = import.meta.env.VITE_PATIENT_PORTAL_API_BASE_URL;
        try {
            await axios.post(
                `${baseURL}/session-history/send-patient-joined-notification/${sessionHistoryId}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${jitsiToken}`,
                        client_id: practice?.client_id,
                        practice_id: practice?.practice_id,
                    },
                }
            );
        } catch (err: unknown) {
            Sentry.logger.error(
                "Could not send client joined notification email at this time",
                {
                    sessionHistoryId,
                    err,
                    userId,
                }
            );
        }
    }, [
        jitsiToken,
        sessionHistoryId,
        userId,
        practice?.client_id,
        practice?.practice_id,
    ]);

    return (
        <div className="h-dvh bg-[#fbfbfb] overflow-y-hidden flex flex-col">
            <div className="h-[8dvh] flex items-center px-24 text-lg shrink-0">
                Session with
                <span className="capitalize inline-block ml-4 font-semibold">
                    {providerName}
                </span>
            </div>

            <div>
                <JitsiComponent
                    clientEmail={email}
                    clientName={clientName}
                    roomName={sessionHistoryId || ""}
                    token={jitsiToken}
                    userId={userId}
                    onConferenceJoined={sendClientJoinedNotification}
                />
            </div>
        </div>
    );
}
